export class UrlHelpers {
    static isExternalLink(url: string): boolean {
        return url.startsWith("http://") || url.startsWith("https://");
    }
}
